var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "default-layout",
    {
      staticClass: "login2",
      attrs: {
        title: "Passkey login → session transfer",
        "sub-title": "Native Passkeys + Native-to-Web SSO POC",
        "logo-src": _vm.logo,
        "logo-alt": "SiteMinder",
      },
    },
    [
      _c("sm-form", { attrs: { id: "login2-form" } }, [
        _c(
          "fieldset",
          [
            _c("p", { staticClass: "hint" }, [
              _vm._v("\n        rpId comes from the tenant custom domain's "),
              _c("code", [_vm._v("relying_party_identifier")]),
              _vm._v(
                ".\n        The transfer token is single-use and lasts ~60s, so the page navigates immediately.\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "sm-button",
              {
                attrs: {
                  id: "login2-inspect",
                  type: "primary",
                  loading: _vm.loading,
                },
                on: {
                  click: function ($event) {
                    return _vm.runFlow("inspect")
                  },
                },
              },
              [_vm._v("\n        Run flow → return here and inspect\n      ")]
            ),
            _vm._v(" "),
            _c(
              "sm-button",
              {
                attrs: {
                  id: "login2-real",
                  type: "secondary",
                  loading: _vm.loading,
                },
                on: {
                  click: function ($event) {
                    return _vm.runFlow("real")
                  },
                },
              },
              [
                _vm._v(
                  "\n        Run flow → real login (/authenticate)\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "sm-button",
              {
                attrs: {
                  id: "login2-grant-only",
                  type: "tertiary",
                  loading: _vm.loading,
                },
                on: { click: _vm.runPasskeyOnly },
              },
              [
                _vm._v(
                  "\n        Diagnostic: webauthn grant only (no transfer, no redirect)\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.status
              ? _c("p", { staticClass: "message" }, [
                  _vm._v("\n        " + _vm._s(_vm.status) + "\n      "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.errorMessage
              ? _c("p", { staticClass: "message message--error" }, [
                  _vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.readout
              ? _c(
                  "div",
                  { staticClass: "readout" },
                  [
                    _c("h6", [_vm._v("id_token from the code exchange")]),
                    _vm._v(" "),
                    _vm._l(_vm.readout, function (row) {
                      return _c(
                        "div",
                        { key: row.label, staticClass: "readout__row" },
                        [
                          _c("span", [_vm._v(_vm._s(row.label))]),
                          _vm._v(" "),
                          _c("span", { class: row.good ? "ok" : "bad" }, [
                            _vm._v(_vm._s(row.value)),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "readout__row" }, [
                      _c("span", [_vm._v("authenticationMethods")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "raw" }, [
                        _vm._v(_vm._s(_vm.authMethods)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.cookieWorks !== null
                      ? _c("div", { staticClass: "readout__row" }, [
                          _c("span", [
                            _vm._v("Auth0 cookie usable (getUserToken)"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { class: _vm.cookieWorks ? "ok" : "bad" },
                            [_vm._v(_vm._s(_vm.cookieWorks ? "YES" : "NO"))]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }